module.exports = __webpack_public_path__ + "img/carritoAzul.5e175294.svg";